import React from 'react';
import styles from "./Welcome.styles";
import commonStyles from "../OnboardingStepsCommonStyles";
import Icons from '../../../components/icons/Icons';
import { VEC_ICON_NAME } from '../../../components/icons/constants';
import Heading from '../../../components/heading/Heading';
import { HEADING } from '../../../components/heading/constants/constants';
import Button from '../../../components/button/Button';
import { BUTTON_TYPE } from '../../../components/button/constants';
import { ONBOARDING_ROUTES } from '../constants';
import { componentKey as authenticationComponentKey } from '../../authentication/AuthenticationSlice';
import { useSelector } from 'react-redux';
import ChangePlan from '../../components/changeplan/ChangePlan';
import { useState } from 'react';
import useTxNavigate from '../../../../libs/txnavigate/TxNavigateHook';

export default function Welcome() {
    const { signedInUser } = useSelector((state) => state[authenticationComponentKey]);
    const [showPlansPopup, setShowPlansPopup] = useState(false);
    const navigate = useTxNavigate();
    return (
        <>
            <div style={styles.negativeMargin}>
                <div style={commonStyles.onboardingStepContainer}>
                    <div style={commonStyles.formDiv}>
                        <div style={styles.stepImageDiv}>
                            <Icons familyName='vec' iconName={VEC_ICON_NAME.WELCOME_STEP_ICON} />
                        </div>
                        <div style={styles.stepTitleContainer}>
                            <Heading type={HEADING.H1}>Welcome to Tax 1099, {signedInUser?.FirstName}!</Heading>
                            <div>
                                <p style={styles.stepTitleDesc}>
                                    We will help you to get started and ready to <br />eFile all your 1099 forms in the next 10 <br />minutes
                                </p>
                            </div>
                        </div>
                        <div style={styles.goButtonDiv}>
                            <Button type={BUTTON_TYPE.PRIMARY}
                                    onClickCb={() => {navigate(`/${ONBOARDING_ROUTES.ONBOARDING}/${ONBOARDING_ROUTES.COMPANY}`)}}
                                    style={styles.goButtonStyle}>
                                Let's go
                            </Button>
                        </div>
                    </div>
                    <div style={styles.welcomeFooter}>
                        <div>
                            <Icons familyName='vec' iconName={VEC_ICON_NAME.API_INTEGRATION_ICON} />
                        </div>
                        <div style={styles.footerRightColumn}>
                            <Heading type={HEADING.H3} customStyle={styles.footerTextHeading}>
                                Need API integration?
                            </Heading>
                            <div style={styles.footerTextRow}>
                                <span>Explore our Enterprise plan for API Services | Integration Services | Notices | User Management</span>
                                <Button type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER} onClickCb={() => setShowPlansPopup(true)}>
                                    Explore our plans
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ChangePlan closePopup={() => setShowPlansPopup(false)} showPopup={showPlansPopup} />
        </>
    )
}